/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRemoteSessionIssuerForm,
  CreateRemoteSessionIssuerForm$Outbound,
  CreateRemoteSessionIssuerForm$outboundSchema,
} from "../components/createremotesessionissuerform.js";

export type CreateRemoteSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateRemoteSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateRemoteSessionIssuerSecurity = {
  option1?: CreateRemoteSessionIssuerSecurityOption1 | undefined;
  option2?: CreateRemoteSessionIssuerSecurityOption2 | undefined;
};

export type CreateRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createRemoteSessionIssuerForm: CreateRemoteSessionIssuerForm;
};

/** @internal */
export type CreateRemoteSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateRemoteSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateRemoteSessionIssuerSecurityOption1$Outbound,
    CreateRemoteSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createRemoteSessionIssuerSecurityOption1ToJSON(
  createRemoteSessionIssuerSecurityOption1:
    CreateRemoteSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    CreateRemoteSessionIssuerSecurityOption1$outboundSchema.parse(
      createRemoteSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateRemoteSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateRemoteSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateRemoteSessionIssuerSecurityOption2$Outbound,
    CreateRemoteSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createRemoteSessionIssuerSecurityOption2ToJSON(
  createRemoteSessionIssuerSecurityOption2:
    CreateRemoteSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    CreateRemoteSessionIssuerSecurityOption2$outboundSchema.parse(
      createRemoteSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateRemoteSessionIssuerSecurity$Outbound = {
  Option1?: CreateRemoteSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: CreateRemoteSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateRemoteSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  CreateRemoteSessionIssuerSecurity$Outbound,
  CreateRemoteSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateRemoteSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateRemoteSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createRemoteSessionIssuerSecurityToJSON(
  createRemoteSessionIssuerSecurity: CreateRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    CreateRemoteSessionIssuerSecurity$outboundSchema.parse(
      createRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type CreateRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateRemoteSessionIssuerForm: CreateRemoteSessionIssuerForm$Outbound;
};

/** @internal */
export const CreateRemoteSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  CreateRemoteSessionIssuerRequest$Outbound,
  CreateRemoteSessionIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createRemoteSessionIssuerForm: CreateRemoteSessionIssuerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createRemoteSessionIssuerForm: "CreateRemoteSessionIssuerForm",
    });
  }),
);

export function createRemoteSessionIssuerRequestToJSON(
  createRemoteSessionIssuerRequest: CreateRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    CreateRemoteSessionIssuerRequest$outboundSchema.parse(
      createRemoteSessionIssuerRequest,
    ),
  );
}
